module.exports = __webpack_public_path__ + "01_hige_black.602f3a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/01_hige_black.png
// module id = UqE8
// module chunks = 0